"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapValues = void 0;
const mapValues = (fn, a) => Object.entries(a).reduce((prev, [key, value]) => Object.assign(prev, { [key]: fn(value) }), {});
exports.mapValues = mapValues;
